import request from '@/utils/request'

 // createBrokenRecord: data => request('/gate/examine/', data), // POST请求
const API = {
	submitConfigInfo: data => request('md_screen_pc_submit_config_values_data', data),
	jk1: data => request('md_screen_get_enterprise_static_data', data, 2), // 大屏--获取企业信息分布（第一模块）
	jk2: data => request('md_screen_get_project_info_static_data', data, 2), // 大屏--获取项目信息分布（第二模块）
	jk3: data => request('md_screen_get_combined_static_data', data, 2),
	getConfig: data => request('md_screen_pc_get_config_detail_data', data, 2),
}

export default API